<script>
import PortalService from "@/api-services/portal.service";

export default {
  name: "onboarding",
  components: {},
  data: function () {
    return {
      username: null,
      password: null,
      otp: "",
      loginOtpStep: false,
      showNas: false,
      validLogin: true,
      validOtp: true,
      usernameRules: [(v) => !!v || "Obligatoire"],
      passwordRules: [(v) => !!v || "Obligatoire"],
      logonError: false,
      loading: false,
      loadingOtp: false,
      isConnected: false,
    };
  },
  methods: {
    getPortalConfiguration: async function () {
      await PortalService.getPortalConfiguration()
        .then((response) => {
          if (response.data.requestResult != null) {
            this.$store.commit(
              "setPortalConfiguration",
              response.data.requestResult
            );
            this.isConnected = true;
          } else {
            this.$router.push("/Maintenance");
          }
        })
        .catch((error) => {
          this.$router.push("/Maintenance");
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log(error.response.data.errorInformation);
          }
        });
    },
    login: async function () {
      this.loading = true;
      this.logonError = false;

      let connectDto = {
        Username: this.username,
        Password: this.password,
        Domain: this.$store.state.portalConfiguration.domainName,
      };

      await PortalService.login(connectDto)
        .then((response) => {
          if (response.data.resultStatus == "Success") {
            this.$store.commit("setJwt", response.data.requestResult);
            this.$store.commit("setIsAuthentified", false);
            this.loginOtpStep = true;
          } else {
            this.$store.commit("setIsAuthentified", false);
            this.username = "";
            this.password = "";
          }
        })
        .catch((error) => {
          this.username = "";
          this.password = "";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.logonError = true;
              this.loginOtpStep = false;
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
        });
      this.loading = false;
    },
    loginOtp: async function () {
      this.loading = true;
      this.logonError = false;

      let connectDto = {
        Password: this.otp,
        Domain: this.$store.state.portalConfiguration.domainName,
      };

      await PortalService.loginOtp(connectDto)
        .then((response) => {
          if (response.data.resultStatus == "Success") {
            this.$store.commit("setJwt", response.data.requestResult);
            this.$store.commit("setIsAuthentified", true);
            this.$router.push("/portal");
          }
        })
        .catch((error) => {
          this.otp = "";
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            if (error.response.status == 401) {
              this.logonError = true;
              this.loginOtpStep = true;
              this.otp = "";
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            this.$store.commit("setNewErrorMessage", error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            this.$store.commit(
              "setNewErrorMessage",
              error.response.data.requestResult
            );
          }
        });
      this.loading = false;
    },
  },

  async created() {
    await this.getPortalConfiguration();
  },
};
</script>

<template>
  <v-container fill-height fluid style="background: white">
    <v-layout align-center justify-center v-if="isConnected">
      <v-card flat>
        <v-card class="elevation-12" width="400">
          <v-card-title class="justify-center ma-5">
            <v-img
              :lazy-src="
                'data:image/jpeg;base64,' +
                this.$store.state.portalConfiguration.logoPortal
              "
              max-height="160"
              max-width="343"
              contain
              :src="
                'data:image/jpeg;base64,' +
                this.$store.state.portalConfiguration.logoPortal
              "
            ></v-img>
          </v-card-title>

          <v-toolbar dark color="primary" height="45px" elevation="8" b>
            <v-spacer></v-spacer>

            <v-toolbar-title>
              <v-img
                class="mt-2"
                lazy-src="monAdnDark.png"
                max-height="100"
                max-width="250"
                contain
                src="monAdnDark.png"
              ></v-img
            ></v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-container>
              <v-form
                v-model="validLogin"
                @submit.prevent="login"
                v-if="!loginOtpStep"
              >
                <v-layout row>
                  <v-flex xs12>
                    <v-card-text
                      v-if="logonError"
                      class="text-caption red--text text-center"
                      >Informations non valide</v-card-text
                    >
                    <v-text-field
                      label="Nom d'utilisateur"
                      v-model="username"
                      :rules="usernameRules"
                      required
                    />
                    <v-text-field
                      @click:append="showNas = !showNas"
                      :append-icon="showNas ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showNas ? 'text' : 'password'"
                      label="Mot de passe"
                      v-model="password"
                      :rules="passwordRules"
                      required
                    />
                  </v-flex>
                </v-layout>
                <v-layout row xs12>
                  <v-flex>
                    <v-btn
                      text
                      block
                      color="primary"
                      :disabled="!validLogin"
                      type="submit"
                      :loading="loading"
                    >
                      Se connecter
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>

              <v-form
                v-model="validOtp"
                v-if="loginOtpStep"
                @submit.prevent.enter="loginOtp"
              >
                <v-row>
                  <v-card-text class="text-center"
                    >Message Challenge</v-card-text
                  >
                  <v-otp-input
                    @finish="loginOtp"
                    type="number"
                    autofocus
                    v-model="otp"
                    length="6"
                    :rules="[(v) => v.length == 6]"
                  ></v-otp-input>
                  <!-- <v-text-field
                    type="tel"
                    autofocus
                    v-model="otp"
                    label="Message challenge"
                  ></v-text-field> -->
                </v-row>
                <v-row>
                  <v-btn
                    text
                    block
                    color="primary"
                    :disabled="otp.length != 6"
                    type="submit"
                    :loading="loading"
                  >
                    Valider
                  </v-btn>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
        </v-card>
        <v-card-text class="text-caption text-right mt-n4"
          >par SecTools</v-card-text
        >
      </v-card>
    </v-layout>
    <v-layout align-center justify-center v-else>
      <div class="text-center pt-10">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <v-card-text class="overline font-weight-light">
          Initialisation en cours
        </v-card-text>
      </div>
    </v-layout>
  </v-container>
</template>
